module.exports = __webpack_public_path__ + "img/1_04.46b2c7ef.jpg";